import * as Yup from 'yup';
import { get } from 'lodash';

import { trims } from 'utils';
import { PhoneService } from '../../../../entities/Phone/service';

Yup.addMethod(Yup.string, 'uniqueOrders', function (parent: string) {
  // @ts-ignore
  return this.test('uniqueOrders', parent, function (obj: string) {
    // @ts-ignore
    const { value } = this.from[1];
    const list = get(value, 'orders');

    const uniqValues = [] as any[];
    const doubles = [] as any[];

    list?.forEach((doc: any) => {
      const val = trims(String(doc[parent]) || '');

      if (uniqValues.includes(val) && !doubles.includes(val)) {
        doubles.push(val);
      } else {
        uniqValues.push(val);
      }
    });
    if (!doubles.includes(trims(obj || ''))) return true;

    return this.createError({
      path: this.path,
      message: 'Вже є у списку',
    });
  });
});

const managerBookingSchema = Yup.object().shape({
  id: Yup.string(),
  bookingStatus: Yup.number().required("Поле обов'язкове"),
  comment: Yup.string().nullable(),
  company: Yup.object().shape({
    iddp: Yup.string().trim().nullable().min(3, 'Введіть не менше 3-х символів'),
    contactPerson: Yup.object().shape({
      firstName: Yup.string()
        .nullable()
        .trim()
        .matches(/^[a-zA-ZА-ЩЬЮЯҐЄІЇа-щьюяґєії\- ']+$/, 'Поле "Ім\'я" повинно містити тільки літери'),
      middleName: Yup.string()
        .nullable()
        .trim()
        .matches(/^[a-zA-ZА-ЩЬЮЯҐЄІЇа-щьюяґєії\- ']+$/, 'Поле "По батькові" повинно містити тільки літери'),
      lastName: Yup.string()
        .nullable()
        .trim()
        .matches(/^[a-zA-ZА-ЩЬЮЯҐЄІЇа-щьюяґєії\- ']+$/, 'Поле "Прізвище" повинно містити тільки літери'),
      email: Yup.object().shape({
        address: Yup.string().nullable().trim().email('Введіть коректний email'),
      }),
    }),
    name: Yup.string().nullable().trim().min(2, 'Введіть не менше 2-х символів'),
  }),
  contactPhone: Yup.object().shape({
    number: Yup.string()
      .required('Поле "Телефон" обов\'язкове')
      .test('len', 'Поле "Телефон" повинно містити 12 символів', (value = '') => {
        const changedValue = PhoneService.unformatPhone(value);
        return changedValue.length === 12;
      }),
  }),
  managerPhone: Yup.object().shape({
    number: Yup.string()
      .required('Поле "Телефон" обов\'язкове')
      .test('len', 'Поле "Телефон" повинно містити 12 символів', (value = '') => {
        const changedValue = PhoneService.unformatPhone(value);
        return changedValue.length === 12;
      }),
  }),
  orders: Yup.array()
    .of(
      Yup.object().shape({
        precomplentation: Yup.boolean(),
        company: Yup.object().shape({
          name: Yup.string(),
          iddp: Yup.string().required("Поле обов'язкове"),
        }),
        orderObject: Yup.string()
          .nullable()
          .required("Поле обов'язкове") // @ts-ignore
          .uniqueOrders('orderObject')
          .min(2, 'Введіть не менше 2-х символів'),
      }),
    )
    .min(1),
});

export default managerBookingSchema;
